package com.rajen.angrejidictionary.presentation.state

import com.rajen.angrejidictionary.domain.model.Word

sealed interface WordUiState {
    data object Loading : WordUiState
    data class Success(val word: Word) : WordUiState
    data class NotFound(val term: String) : WordUiState
    data class Error(val message: String) : WordUiState
}